export default "__VITE_ASSET__0JL1TGg$__"